/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { getEnvironment } from 'src/core/utils/api/environment';
import { urlBuilder } from 'src/core/utils/api/urlBuilder';
import { extractOrigin } from 'src/core/utils/endpointBuilder/extractOrigin';
import { EndpointUrlParams } from 'src/core/utils/endpointBuilder/types';

/**
 * Builds the endpoint url with the given params for the given
 * endpoint.
 */
export const buildConversationEndpointUrl = (urlParams: EndpointUrlParams, hideSubscriptionKey = false): string => {
    const { base, appId, slot, query, verbose = true, allIntents = false, log = true, subscriptionKey, spellCheck } = urlParams;

    let builder = urlBuilder()
        .baseUrl(`${extractOrigin(base)}/${getEnvironment().isProduction ? 'luis/prediction/' : ''}v3.0`)
        .app(<string>appId)
        .resource('slots', slot)
        .resource('predict')
        .queryParam('verbose', String(verbose))
        .queryParam('show-all-intents', String(allIntents))
        .queryParam('log', String(log));

    if (!hideSubscriptionKey) {
        builder = builder.queryParam('subscription-key', subscriptionKey ?? '<YOUR_RESOURCE_KEY>');
    }

    if (spellCheck) {
        builder = builder.queryParam('mkt-bing-spell-check-key', spellCheck);
    }

    builder = builder.queryParam('query', (query || 'YOUR_QUERY_HERE').replace('&', '%26'));

    return builder.build();
};
